// Phase 4 fleet constants & French labels.
export const RESOURCE_TYPES = ["QUAD", "BUGGY", "JET_SKI", "BOAT", "HORSE", "CAMEL", "BIKE", "SCOOTER", "KART", "OTHER"];

export const RESOURCE_STATUS = {
  AVAILABLE: { label: "Disponible", badge: "bg-emerald-50 text-emerald-700" },
  IN_USE: { label: "En activité", badge: "bg-blue-50 text-blue-700" },
  MAINTENANCE: { label: "En maintenance", badge: "bg-amber-50 text-amber-700" },
  OUT_OF_SERVICE: { label: "Hors service", badge: "bg-rose-50 text-rose-700" },
};

export const MAINT_STATUS = {
  SCHEDULED: { label: "Planifiée", badge: "bg-slate-100 text-slate-600" },
  IN_PROGRESS: { label: "En cours", badge: "bg-amber-50 text-amber-700" },
  COMPLETED: { label: "Terminée", badge: "bg-emerald-50 text-emerald-700" },
  CANCELLED: { label: "Annulée", badge: "bg-slate-100 text-slate-400" },
};

export const MAINT_TYPES = { ROUTINE: "Entretien", REPAIR: "Réparation", INSPECTION: "Contrôle", OTHER: "Autre" };

export const INC_SEVERITY = {
  LOW: { label: "Faible", badge: "bg-slate-100 text-slate-600" },
  MEDIUM: { label: "Moyenne", badge: "bg-amber-50 text-amber-700" },
  HIGH: { label: "Élevée", badge: "bg-orange-50 text-orange-700" },
  CRITICAL: { label: "Critique", badge: "bg-rose-50 text-rose-700" },
};

export const INC_STATUS = {
  OPEN: { label: "Ouvert", badge: "bg-rose-50 text-rose-700" },
  RESOLVED: { label: "Résolu", badge: "bg-emerald-50 text-emerald-700" },
  CANCELLED: { label: "Annulé", badge: "bg-slate-100 text-slate-400" },
};

export const FLEET_ACTION_LABELS = {
  "resource.created": "Ressource créée", "resource.updated": "Ressource modifiée",
  "resource.status_changed": "Statut de la ressource modifié",
  "maintenance.created": "Maintenance créée", "maintenance.started": "Maintenance démarrée",
  "maintenance.completed": "Maintenance terminée", "maintenance.cancelled": "Maintenance annulée",
  "maintenance.expense_linked": "Dépense liée à la maintenance",
  "incident.reported": "Incident signalé", "incident.updated": "Incident modifié",
  "incident.resolved": "Incident résolu", "incident.cancelled": "Incident annulé",
  "expense.created": "Dépense créée",
  "resource.archived": "Ressource archivée", "resource.unarchived": "Ressource rétablie",
};
